export const SET_PROPERTY_HISTORY = 'SET_PROPERTY_HISTORY'
export const RESET_PROPERTY_HISTORY = 'RESET_PROPERTY_HISTORY'
